import React from "react";
import { useParams } from "react-router-dom";
import './AdminPortal.css';

const AdminPortal = () => {
    const { aduser } = useParams();

    return (
        <div className="lern-adminportal">
            Admin Portal: {aduser}
        </div>
    )
}

export default AdminPortal;